<template>
    <div class="position-relative">
        <v-app class="p-5">
            <bank-cards url="user/bought/archives"></bank-cards>
        </v-app>
    </div>
</template>

<script>
import TitleRibbon from "../uiBeautifier/titleRibbon";
import bankCards from "../createBankPack/BankCards"
export default {
    name: "boughtArchives",
    components:{TitleRibbon,bankCards}
}
</script>

<style scoped>

</style>